import { createSelector } from 'reselect';

import { Store, UserRoleEnum, UserType } from '../types';

const selectUser = (state: Store): UserType | null => state.session.user;

export const memoizedSelectUserRoles = createSelector([selectUser], (user) => {
  const defaultUserRoles = new Set([
    UserRoleEnum.VIEW_CONTACT_CSE,
    UserRoleEnum.VIEW_CREDS_MGMT,
    UserRoleEnum.VIEW_CUST_SWITCH,
    UserRoleEnum.VIEW_DATA,
    UserRoleEnum.VIEW_MSPSWITCH,
    UserRoleEnum.VIEW_LOG_SEARCH,
    UserRoleEnum.VIEW_TICKETS,
  ]);

  if (!user) {
    return defaultUserRoles;
  }

  const { roles } = user;

  if (!roles) {
    return defaultUserRoles;
  }

  return new Set(roles);
});
